<template>
  <div class="jl-case-wrap">
    <div class="jl-container">
      <div class="jl-case-content" v-html="info"></div>
    </div>
  </div>
</template>

<script>
import { caseInfo } from "@/api/case";
export default {
  name: "caseIndex",
  data() {
    return {
      info: ""
    };
  },
  created() {
    caseInfo(this);
  }
};
</script>

<style lang="scss" scoped>
.jl-container {
  max-width: 1200px;
  margin: 0 auto;
  padding-bottom: 120px;
}
.jl-case-content {
  padding-top: 30px;
}
</style>
